import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInWeeks,
} from 'date-fns';

/**
 * Compact relative time — "just now" / "20m ago" / "3h ago" / "2d ago" / "1w ago".
 * A future/near-now timestamp (or clock skew) reads as "just now".
 */
export function timeAgo(iso: string): string {
  const now = new Date();
  const date = new Date(iso);

  const minutes = differenceInMinutes(now, date);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;

  const hours = differenceInHours(now, date);
  if (hours < 24) return `${hours}h ago`;

  const days = differenceInDays(now, date);
  if (days < 7) return `${days}d ago`;

  return `${differenceInWeeks(now, date)}w ago`;
}
